export default {
  INIT: 'STATISTICS/INIT',
  UPDATE_DATA: 'STATISTICS/UPDATE_DATA',
  UPDATE_REGISTERED_USERS: 'STATISTICS/UPDATE_REGISTERED_USERS',
  UPDATE_ACTIVATED_USERS: 'STATISTICS/UPDATE_ACTIVATED_USERS',
}
